export default {
    format_date(date) {
        if (!date) return '';
        return new Date(date).toLocaleString("en-GB", {
            hour12: false,
        });
    }
}